
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.625 8.16a5.674 5.674 0 00-11.3 0l-.407 4.476a1.14 1.14 0 01-.626.916l-.003.001A2.332 2.332 0 004 15.64v.348a2.05 2.05 0 002.05 2.051H17.9a2.05 2.05 0 002.05-2.05v-.349c0-.883-.499-1.69-1.289-2.086l-.003-.001a1.14 1.14 0 01-.625-.916l-.407-4.476zm-9.94.124a4.306 4.306 0 018.579 0l.406 4.475a2.508 2.508 0 001.379 2.017.965.965 0 01.533.863v.348a.684.684 0 01-.683.684H6.05a.684.684 0 01-.684-.684v-.348c0-.365.207-.7.537-.865a2.506 2.506 0 001.375-2.014l.407-4.476z"}}),_c('path',{attrs:{"d":"M13.114 17.582v.912a1.14 1.14 0 11-2.279 0v-.912H9.468v.912a2.506 2.506 0 005.013 0v-.912h-1.367z"}})])
          )
        }
      }
    